import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { CloseIcon } from '../icons';
import { FaAngleLeft } from 'react-icons/fa';

import { ProfileContext } from '../../contexts/ProfileContext';

const FullPagePopup = ({ closeLink = '/my-profile', onCloseCallback, children }) => {
  const navigate = useNavigate();
  const [profile] = useContext(ProfileContext);
  const { masterData: { customConfigurations: { colors } = {} } = {} } = profile;

  const handleClose = () => {
    if (onCloseCallback) {
      onCloseCallback(() => navigate(closeLink));
      return;
    }
    navigate(closeLink);
  };

  return (
    <div className="fixed lg:relative top-0 left-0 w-full h-screen lg:h-auto lg:min-h-screen z-[60] lg:z-auto bg-transparent lg:bg-white">
      {/* Mobile overlay */}
      <div className="lg:hidden bg-grey-100 opacity-40 h-screen w-full" onClick={handleClose} />

      {/* Container - mobile: bottom sheet, desktop: full page */}
      <div className="fixed lg:static h-[88vh] lg:h-auto bottom-0 left-0 w-full rounded-t-3xl lg:rounded-none bg-white shadow-[0px_4px_20px_0px_rgba(0,0,0,0.15)] lg:shadow-none">
        {/* Mobile header with drag handle and close */}
        <div className="lg:hidden flex h-[5%] items-center justify-center">
          <span className="relative bg-black opacity-20 h-[2px] w-24" />
          <button
            className="p-1 rounded-full bg-grey-100 absolute right-3 top-3"
            onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>

        {/* Desktop header with back button */}
        <div className="hidden lg:flex justify-start p-4">
          <button
            className="text-white p-1.5 rounded-lg hover:opacity-90 transition-opacity ml-1"
            style={{ backgroundColor: colors?.primary || '#2B4B8C' }}
            onClick={handleClose}>
            <FaAngleLeft className="text-2xl" />
          </button>
        </div>

        {/* Content - single children render */}
        <div className="h-[95%] lg:h-auto overflow-y-auto overflow-x-hidden p-10 pb-10 lg:px-10 lg:pb-10">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FullPagePopup;
